module.exports = __webpack_public_path__ + "img/whats-bag2.4f335bfa.svg";